import React, { useState, useEffect } from 'react';
import { createMarkup } from '../../../../../../Foundation/React/code/Utilities/HelperUtilities.js';
import Button from './Button.js';
import Input from './Input.js';
import { zipCodeHasErrors } from '../../../../../../Foundation/React/code/Utilities/AddressValidation.js';
import { fetchPromise } from './apiHelper.js';
import { emailHasErrors } from '/Foundation/Common/code/Helpers/ValidationHelper';

export default (props) => {
  const [orderNumber, setOrderNumber] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showOrderNoError, setShowOrderNoError] = useState(false);
  const [showZipCodeError, setShowZipCodeError] = useState(false);
  const [showEmailError, setShowEmailError] = useState(false);

  useEffect(() => {
    if (errorMessage) {
      props.scrollToTop();
    }
  }, [errorMessage]);

  const findOrder = (e) => {
    e.preventDefault();
    setErrorMessage('');
    setIsLoading(true);

    var validated = validateFormData(orderNumber.trim(), zipCode.trim(), email.trim(), props.Market);
    if (!validated) {
      setIsLoading(false);
      return;
    }

    const url = '/api/sitecore/returns/FindOrder';
    const options = {
      method: 'POST',
      body: JSON.stringify({
        OrderNumber: orderNumber.trim(),
        ZipCode: zipCode.trim(),
        Email: email.trim(),
      }),
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    };
    try {
      fetchPromise(url, options)
        .then((response) => {
          if (response?.Success) {
            props.setCurrentOrder(response);
            props.setShowStartForm(false);
            props.setShowHomeDeliveryDesc(response.ShipMethodIsHomeDelivery);
            props.scrollToTop();
          } else if (response?.Messages.length > 0 && response?.Messages[0].Content) {
            setErrorMessage(response.Messages[0].Content);
          } else if (response?.Errors.length > 0 && typeof response?.Errors[0] === 'string') {
            setErrorMessage(response.Errors[0]);
          } else {
            setErrorMessage(props.GeneralErrorMessage);
          }
        })
        .then(() => {
          setIsLoading(false);
        });
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  /* Checks all inputs and returns false if any of the values are invalid */
  const validateFormData = (orderNumber, zipCode, email, countryCode) => {
    var validated = {
      orderNumber: validateOrderNumber(orderNumber),
      zipCode: validateZipCode(zipCode, countryCode),
      email: validateEmail(email),
    };
    for (var key in validated) {
      if (!validated[key]) {
        return false;
      }
    }
    return true;
  };

  const validateOrderNumber = (orderNumber) => {
    var validated = orderNumber.length > 0;
    if (!validated) {
      setShowOrderNoError(true);
      return false;
    }
    setShowOrderNoError(false);
    return true;
  };

  const validateZipCode = (zipCode, countryCode) => {
    let validated = !zipCodeHasErrors(zipCode, countryCode);

    if (!validated) {
      setShowZipCodeError(true);
      return false;
    }
    setShowZipCodeError(false);
    return true;
  };

  const validateEmail = (email) => {
    if (emailHasErrors(email)) {
      setShowEmailError(true);
      return false;
    }
    setShowEmailError(false);
    return true;
  };

  return (
    <div id="find-order-form-container" className="container">
      <div className="col-xs-12 col-lg-10 col-xl-8 offset-xl-2 offset-lg-1 no-padding-left">
        {errorMessage && (
          <div className="error-msg-container">
            <p className="error-msg" dangerouslySetInnerHTML={createMarkup(errorMessage)} />
            <div className="msg-close" onClick={() => setErrorMessage('')}>
              <i className="fa fa-times"></i>
            </div>
          </div>
        )}

        <h1 className="headline">{props.Heading}</h1>
        {props.showStartForm ? (
          <>
            <div dangerouslySetInnerHTML={createMarkup(props.Description)} />
            <form onSubmit={(e) => findOrder(e)}>
              <div className="form-group form-group-custom">
                <Input
                  onBlur={(e) => validateOrderNumber(e.target.value.trim())}
                  value={orderNumber}
                  onChange={(e) => setOrderNumber(e.target.value)}
                  error={showOrderNoError}
                  errorlabel={props.OrderNumberError}
                  label={props.OrderNumberLabel}
                />
              </div>
              <div className="form-group form-group-custom">
                <Input
                  onBlur={(e) => validateZipCode(e.target.value.trim(), props.Market)}
                  value={zipCode}
                  onChange={(e) => setZipCode(e.target.value)}
                  error={showZipCodeError}
                  errorlabel={props.ZipCodeError}
                  label={props.ZipCodeOfBillingAddressLabel}
                />
              </div>
              <div className="form-group form-group-custom">
                <Input
                  onBlur={(e) => validateEmail(e.target.value.trim())}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={showEmailError}
                  errorlabel={props.EmailError}
                  label={props.EmailLabel}
                />
              </div>
              <Button
                type={'submit'}
                onClick={(e) => findOrder(e)}
                className="thule-btn-default"
                loading={isLoading}
                disabled={isLoading}
              >
                {props.ButtonFindOrder}
              </Button>
            </form>
          </>
        ) : (
          <div className="tpd-loader">
            <div className="tpd-spinner" />
          </div>
        )}
      </div>
    </div>
  );
};
